import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2"; // Importar SweetAlert2
import "./SubirExistencias.css";

const SubirExistencias = () => {
  const [archivo, setArchivo] = useState(null);
  const [categoria, setCategoria] = useState("");

  const handleArchivoChange = (e) => {
    setArchivo(e.target.files[0]);
  };

  const handleSubirArchivo = async (e) => {
    e.preventDefault();
    if (!archivo || !categoria) {
      Swal.fire({
        title: "Campos incompletos",
        text: "Por favor selecciona un archivo XML y una categoría.",
        icon: "warning",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", archivo);
    formData.append("almacen", categoria);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/cedis/upload-existencias/`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      Swal.fire({
        title: "Archivo subido",
        text: response.data.message,
        icon: "success",
        confirmButtonText: "Aceptar",
      });
    } catch (error) {
      console.error("Error al subir el archivo:", error);
      Swal.fire({
        title: "Error al subir el archivo",
        text: "Hubo un problema al subir el archivo. Por favor, inténtalo nuevamente.",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    }
  };

  const almacenes = ["GC1", "GC2", "GP1", "GP2", "OFERTAS", "PD", "PEPSI-COCA"];

  return (
    <div className="subir-existencias-container">
      <h2>Subir Existencias de CEDIS</h2>
      <form onSubmit={handleSubirArchivo}>
        <input type="file" accept=".xml" onChange={handleArchivoChange} required />
        <select
          value={categoria}
          onChange={(e) => setCategoria(e.target.value)}
          required
        >
          <option value="">ALMACEN</option>
          {almacenes.map((alm) => (
            <option key={alm} value={alm}>{alm}</option>
          ))}
        </select>
        <button type="submit">Subir Archivo</button>
      </form>
    </div>
  );
};

export default SubirExistencias;